module.exports = __webpack_public_path__ + "static/image/font/pc/bmjua-1@3x.jpg?f3d61349";